var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandle = function SvgHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7072 1.70616C16.0975 1.31585 16.0975 0.683039 15.7072 0.292731C15.3169 -0.0975775 14.6841 -0.0975769 14.2938 0.292732L0.292731 14.2938C-0.0975775 14.6841 -0.0975769 15.3169 0.292732 15.7072C0.683041 16.0976 1.31586 16.0976 1.70617 15.7072L15.7072 1.70616ZM15.7073 9.04133C16.0976 8.65102 16.0976 8.01821 15.7073 7.6279C15.317 7.23759 14.6841 7.23759 14.2938 7.6279L7.62792 14.2938C7.23761 14.6841 7.23761 15.3169 7.62792 15.7073C8.01823 16.0976 8.65105 16.0976 9.04136 15.7073L15.7073 9.04133Z"
  })));
};
export default SvgHandle;